import { useState } from 'react';

/**
 * Marca "mensagem enviada" guardada no navegador, por item. Mesmas chaves de
 * localStorage que os cards antigos usavam, para não perder o que já foi marcado.
 */
function useSentFlag(storageKey) {
  const [sent, setSent] = useState(() => Boolean(localStorage.getItem(storageKey)));

  const markSent = () => {
    localStorage.setItem(storageKey, 'true');
    setSent(true);
  };

  return [sent, markSent];
}

export default useSentFlag;
